import { useState } from "react";
import { handleEntriesTopVehicles } from "../../../api/entries";
import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";
import { Empty, Spin } from "antd";
import AllModels from "./AllModels";

export default function TopModels({ filters }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(10);

  const params = `limit=${limit}&startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;

  const { data: entries, isLoading } = useQuery({
    queryKey: ["topVehicles", params],
    queryFn: () => handleEntriesTopVehicles({ params }),
  });
  return (
    <div className="">
      <div className="border-b-4 border-orange-100 bg-orange-50 p-2  flex justify-between">
        <div className="font-bold">TOP 10 MODELS</div>
        <button
          onClick={() => setVisible(true)}
          className="flex justify-center items-center text-gray-600"
        >
          View All <ChevronRight size={15} />
        </button>
      </div>
      <div className="p-2">
        {isLoading ? (
          <div className="flex justify-center items-center h-96">
            <Spin />
          </div>
        ) : (
          <div className="">
            {!entries || entries?.length === 0 ? (
              <Empty />
            ) : (
              <div className="">
                {entries?.map((item: any, index: number) => (
                  <div
                    className={`flex justify-between p-1 ${
                      index % 2 ? "" : "bg-gray-50"
                    }`}
                    key={index}
                  >
                    <div className="flex w-3/4">
                      <div className="mr-2">{index + 1}.</div>
                      <div className="flex flex-col">
                        <div
                          className="uppercase truncate"
                          style={{ fontSize: 10 }}
                        >
                          {item?.groupedModelName}
                        </div>
                        <div className="text-gray-500" style={{ fontSize: 8 }}>
                          {item?.uniqueMakeNames[0]}
                        </div>
                      </div>
                    </div>
                    <div className="w-1/4 flex justify-end">
                      <span>
                        {/* <span className="font-bold mx-1">{item?.totalCount}</span> */}
                        {/* <span className="mx-2">Entries</span> */}
                      </span>
                      <span className="text-gray-500">
                        {" "}
                        {item?.percentage}%{" "}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      {isVisible && (
        <AllModels
          isVisible={isVisible}
          setVisible={setVisible}
          filters={filters}
        />
      )}
    </div>
  );
}
